import request from '@/utils/request';

/**
 * 钱包余额
 * @param {*} data 
 */
export function balance(data) {
  return request({
    url: '/wallet/balance',
    method: 'post',
    data
  });
}

/**
 * 提现申请列表
 * @param { page: 分页，count： 一页显示多少条 } data 
 */
export function settlementList(data) {
  return request({
    url: '/wallet/settlement-list',
    method: 'post',
    data
  });
}
/**
 * 结算申请详情
 * @param { id: 结算申请id } data 
 */
export function settlementDetail(data) {
  return request({
    url: '/wallet/settlement-detail',
    method: 'post',
    data
  });
}

/**
 * 结算申请财务审核
 * @param { id: 结算id, status: 0财务处理中 | 1已结算, remark?: 备注, content?: 图片 } data
 */
export function settlementUpdate(data) {
  return request({
    url: '/wallet/settlement-update',
    method: 'post',
    data
  });
}
/**
 * 提现申请
 * @param { expressNumber: 快递单号, tradeMoney: 提现金额 } data 
 */
export function withdrawal(data) {
  console.log(data, 'cccc');
  return request({
    url: '/wallet/withdrawal',
    method: 'post',
    data
  });
}